import React from "react";
import * as MaterialDesignIcons from "react-icons/md";
import { Link } from "react-router-dom";
import { ITranslations } from "../data/strings";
import IFamily from "../models/IFamily";
import { ELCID, IMediaPlanPage } from "../models/IMediaToolkit";

export interface IMobileMenuProps {
    pages: IMediaPlanPage[];
    family: IFamily;
    curPageIdx: number;
    navOpen: boolean;
    lcid: ELCID;
    translations: ITranslations;
    setNavOpen: (newState: boolean) => void;
}

export const MobileMenu: React.FunctionComponent<IMobileMenuProps> = (props) => {
    return (
        <div
            className={`whitebox bg-aap-cream-400 bg-opacity-60 fixed top-9 sm:top-12 md:top-[44px] lg:top-[56px] left-0 right-0 bottom-0 z-[1100] transition-opacity ${
                props.navOpen ? `opacity-100` : `opacity-0 pointer-events-none`
            }`}
            onClick={() => props.setNavOpen(false)}
        >
            <div
                className={`menu overflow-auto bg-aap-gray-500 text-white absolute top-0 bottom-0 w-96 shadow-xl shadow-aap-gray-500 transition-all ${
                    props.navOpen ? `left-0` : `-left-96`
                }`}
            >
                <div className="absolute top-5 right-5">
                    <button
                        type="button"
                        onClick={() => props.setNavOpen(false)}
                        id={`btn_mobileMenuClose_${ELCID[props.lcid]}`}
                    >
                        <MaterialDesignIcons.MdClose size={32} />
                    </button>
                </div>
                <div className="bg-aap-gray-400 text-white p-5 text-xl">{props.translations.familyMediaPlan}</div>
                {props.pages.map((page) => {
                    let pageIdx = props.pages.map((propPage) => propPage.identifier).indexOf(page.identifier);
                    const pageIsPriority =
                        !page.availablePriority ||
                        (page.availablePriority && props.family.priorities.indexOf(page.spoId) > -1);
                    let stepCompleted = false;
                    let currentStep = false;
                    let iconObj = MaterialDesignIcons[page.icon as keyof typeof MaterialDesignIcons];

                    if (!iconObj) {
                        // fallback if icon doesn't exist above
                        iconObj = MaterialDesignIcons["MdErrorOutline"];
                    }

                    let checkboxClasses = "bg-aap-gray-400 border border-aap-gray-100";
                    let textClasses = `text-white font-semibold`;

                    if (pageIdx < props.curPageIdx) {
                        // already completed steps
                        stepCompleted = true;
                        checkboxClasses = "bg-aap-green-500 text-white";

                        // for non-priority steps
                        if (!pageIsPriority) {
                            // checkboxClasses = 'bg-aap-green-500 text-white';
                        }
                    } else if (props.curPageIdx === pageIdx) {
                        // current step
                        currentStep = true;
                        checkboxClasses = "bg-aap-red-500 text-white";
                    } else {
                        // future step
                        // defaults already defined above

                        // for non-priority steps
                        if (!pageIsPriority) {
                            // checkboxClasses = 'bg-aap-cream-500 text-aap-gray-300 shadow-none border border-aap-gray-300';
                        }
                    }

                    if (!pageIsPriority) {
                        textClasses = `italic text-aap-gray-200`;
                    }

                    return (
                        <Link
                            to={page.navigateTo}
                            onClick={() => props.setNavOpen(false)}
                            className={`p-5 ${textClasses} text-sm flex justify-between`}
                            key={`mobile-link-${page.identifier}`}
                            id={`btn_mobileMenuLink_${page.identifier}_${ELCID[props.lcid]}`}
                        >
                            <div className="content-evenly pt-1">{page.title}</div>
                            <div className={`relative rounded-full w-8 h-8 ${checkboxClasses}`}>
                                {stepCompleted ? (
                                    <MaterialDesignIcons.MdCheck
                                        size={28}
                                        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                                    />
                                ) : null}
                                {currentStep ? (
                                    <div className="w-3 h-3 rounded-full bg-white absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"></div>
                                ) : null}
                            </div>
                        </Link>
                    );
                })}
            </div>
        </div>
    );
};
